//Local Imports
import { Axios } from "../axios";
import { IRemitter } from "./remitter";
//End Local Import

export const sendOtp = async ({ body, apiType }: IRemitter.ISendOtpProps) => {
  let end_of_url = "";

  if (body.otpType === "mobile") {
    end_of_url = "sendMobileOtp";
  }

  if (body.otpType === "email") {
    end_of_url = "sendEmailOtp";
  }

  if (apiType === "resend") {
    end_of_url = "resendOtp";
  }

  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(`/remit/auth/${end_of_url}`, body, {
    headers: {
      "partner-type": currentUser?.partner_type,
    },
  });
};

export const validateOtp = async (body: IRemitter.IValidateOtpProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post("/remit/auth/validateOtp", body, {
    headers: {
      "partner-type": currentUser?.partner_type,
    },
  });
};

export const remitterSignUp = async (body: IRemitter.ISignUpProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(`/remit/auth/user/${currentUser.vendor_key}/signup`, body, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const userRegistrationDetails = async (body: IRemitter.IUserRegistrationProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const { UserKey, page, size, ascending, filter } = body;

  return await Axios.get(`/remit/auth/user/${UserKey}/getUserRegDetails`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
    params: {
      page: page,
      size: size,
      ascending: ascending,
      filter: filter,
    },
  });
};

export const deleteRemitter = (userKey: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return Axios.delete(`/remit/auth/vendor-user/${userKey}`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const checkKycStatus = async (id: number) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.get(`/remit/kyc/status/${id}`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const resendKycLink = async (id: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.get(`/remit/kyc/link/${id}`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};
